import { render, staticRenderFns } from "./VendorMembers.vue?vue&type=template&id=72cf5cd3&"
import script from "./VendorMembers.vue?vue&type=script&lang=js&"
export * from "./VendorMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports